<template>
    <div class="p-3">
        <h3>Scan Berkas RM Details</h3>
        <hr>

        <div class="row">
            <div class="col-sm-3">
                <h4 class="mb-3">Data Pasien</h4>

                <table class="table table-striped">
                    <tbody>
                        <tr v-for="(pasien, idx) in detail_pasien" :key="idx">
                            <td>{{ idx }}</td>
                            <td>{{ pasien }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-9">
                <h4 class="mb-3">Berkas</h4>

                <div class="row">
                    <div class="col-md-6">
                        <div class="input-group">
                            <span class="input-group-text">IP WebSocket Scanner</span>
                            <input type="text" aria-label="IP WebSocket" class="form-control" v-model="ip_scanner">
                            <span class="input-group-text">Port</span>
                            <input type="text" aria-label="Port" class="form-control" v-model="port" disabled>
                            <button class="btn btn-success" @click="scanDocs">Scan</button>
                            <!-- <button class="btn btn-primary" @click="testSimScan">Test</button> -->
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <span class="input-group-text">Berkas</span>
                            <select name="berkas" id="berkas" v-model="file_berkas" class="form-select">
                                <option value="0">--- Pilih Berkas ---</option>
                                <template v-if="berkas_pasien.length > 0">
                                    <option v-for="(bp, idx) in berkas_pasien" :key="idx" :value="bp.id">{{ bp.doc_title }}</option>
                                </template>
                            </select>
                            <input type="file" aria-label="Upload File" class="form-control" ref="file_upload" accept="image/*,application/pdf" />
                            <button class="btn btn-primary" @click="handleFileUpload">Upload File</button>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col" id="table-berkas-pasien"></div>
                </div>
            </div>
        </div>

        <div class="modal" ref="modal_scan" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Scan Dokument</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <div class="card" style="width: 100%;">
                                    <div class="card-body">
                                        <button class="btn btn-sm btn-primary" @click="startScan">Scan</button>
                                        <div v-if="proses_scan" class="alert alert-info mt-3" role="alert">
                                            Proses Scan Dokumen...
                                        </div>
                                        <p class="mt-3" v-if="thumbnail.length > 0">Klik pada gambar untuk melihat preview</p>

                                        <template v-if="thumbnail.length > 0">
                                            <img v-for="(thumb, idx) in thumbnail" :key="idx" :src="thumb" alt="preview-image" style="width: 100%;" @click="previewImage(thumb)">
                                        </template>

                                        <div class="row mt-3">
                                            <label for="title" class="col-sm-4">Judul</label>
                                            <div class="col-sm-8">
                                                <input type="text" v-model="data_berkas.doc_title" id="title" class="form-control">
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <label for="desc" class="col-sm-4">Keterangan</label>
                                            <div class="col-sm-8">
                                                <input type="text" v-model="data_berkas.doc_description" id="desc" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="saveThumbnail">Save changes</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" ref="modal_preview" tabindex="-1">
            <div class="modal-dialog modal-dialog-scrollable modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Preview</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <img v-if="preview_scan" :src="preview_scan" alt="" style="width: 100%;">
                                <div v-if="pdf_preview && pdf_pages">
                                    <div v-for="(page, idx) in pdf_pages" :key="idx">
                                        <canvas :ref="`pdf_canvas` + idx"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="file_upload" type="button" class="btn btn-success" @click="doUploadFile">Upload</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import pdfjsLib from 'pdfjs-dist/build/pdf'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

export default {
    data() {
        return {
            ip_scanner: '127.0.0.1',
            port: '4649',
            proses_scan: false,
            Medrec: '',
            detail_pasien: [],
            master_pasiens: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            },
            scan_command: {
                command: 'scan',
                quality: 60,
                format: 'jpeg'
            },
            identity_command: {
                command: 'identity'
            },
            set_source_command: {
                command: 'setSource',
                value: 0
            },
            scanner_counter: 1,
            ws_mdl: null,
            ws_ctwain: null,
            valid_mime_regex: /^data:(application\/pdf|image\/.+);base64/,
            pdf_placeholder: '/assets/images/pdf.png',
            address: '',
            thumbnail_id: 0,
            thumbnail: [],
            data_berkas: {
                medrec: '',
                doc_path: '',
                doc_title: '',
                doc_description: ''
            },
            modal_element: null,
            berkas_pasien: [],
            preview_scan: null,
            file_berkas: 0,
            file_upload: null,
            pdf_preview: null,
            pdf_pages: []
        }
    },
    created() {
        //
    },
    mounted() {
        this.Medrec = this.$route.params.Medrec
        this.getDetailPasien()
    },
    methods: {
        // testSimScan() {
        //     this.data_berkas.medrec = this.Medrec
        //     this.data_berkas.doc_title = 'Test Doc'
        //     this.data_berkas.doc_description = 'Test Doc Desc'
        //     this.data_berkas.doc_path = [`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVsAAAEqCAYAAAC7sfOJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAPlSURBVHhe7dRBAQAwCAChVbF/SJfCe0EI3swsALdkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLEJAtQEC2AAHZAgRkCxCQLUBAtgAB2QIEZAsQkC1AQLYAAdkCBGQLcG73Axpbvx8F2+4kAAAAAElFTkSuQmCC`]
        //     const uri = '/api/scan-berkas-rm/save-berkas'

        //     this.axios.post(uri, this.data_berkas).then(response => {
        //         if (response.data.status == 'success') {
        //             this.getBerkasPasien()
        //             this.modal_element.hide()
        //         }
        //     })
        // },
        getDetailPasien() {
            const uri = `/api/merge-pasien/get-detail-pasien?Medrec=${this.Medrec}`

            this.axios.get(uri).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.detail_pasien = response.data.pasien

                    this.getBerkasPasien()
                }
            })
        },
        getBerkasPasien() {
            const uri = `/api/scan-berkas-rm/get-berkas-pasien?medrec=${this.Medrec}`

            const element = document.getElementById('table-berkas-pasien')

            const previewBerkasInfo = function (cell) {
                const data = cell.getRow().getData()
                const files = data.berkas_rm_files ?? []
                const wrapper = document.createElement('div')

                if (files.length > 0) {
                    files.forEach((img) => {
                        const docWrapper = document.createElement('div')
                        docWrapper.className = 'mb-2 d-flex align-items-center justify-content-between'

                        const fileName = img.file_name.replace('/berkas_rm/', '')
                        const textNode = document.createTextNode(fileName)
                        docWrapper.appendChild(textNode)

                        const actionContainer = document.createElement('div')
                        actionContainer.className = 'text-end'
                        actionContainer.innerHTML = `<button class="btn btn-sm btn-primary me-1" data-id="${img.id}" data-file_name="${img.file_name}" data-action="preview"><i class="fa fa-search" data-id="${img.id}" data-file_name="${img.file_name}" data-action="preview"></i></button>
                            <button class="btn btn-sm btn-danger" data-id="${img.id}" data-file_name="${img.file_name}" data-action="delete"><i class="fa fa-trash" data-id="${img.id}" data-file_name="${img.file_name}" data-action="delete"></i></button>`
                        docWrapper.appendChild(actionContainer)
                        wrapper.appendChild(docWrapper)
                    })
                } else {
                    wrapper.textContent = 'Tidak ada berkas'
                }

                return wrapper
            }

            const updateKeterangan = (cell) => {
                const cell_data = cell.getRow().getData()
                console.log('cell row data', cell_data)
                const uri = '/api/scan-berkas-rm/update-keterangan-berkas-pasien'

                this.axios.post(uri, {id: cell_data.id, keterangan: cell_data.doc_description}).then(response => {
                    if (response.data.status == 'success') {
                        this.$swal.fire({
                            title: 'Berhasil!',
                            text: "Data Berhasil diupdate",
                            icon: 'success',
                            confirmButtonText: 'OK'
                        })
                        this.getDetailPasien()
                    } else {
                        this.$swal.fire({
                            title: 'Error!',
                            text: response?.data?.message ?? 'Data gagal diupdate',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }
                })
            }

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',
                rowFormatter: function (row) {
                    const data = row.getData()
                    const files = data.berkas_rm_files ?? []

                    if (files.length === 0) {
                        return
                    }

                    const holder = document.createElement('div')
                    holder.className = 'berkas-row-details'
                    holder.style.padding = '10px 16px'
                    holder.style.width = '100%'
                    holder.style.boxSizing = 'border-box'

                    files.forEach((img) => {
                        const docWrapper = document.createElement('div')
                        docWrapper.className = 'mb-3'

                        if (img.file_name.includes('berkas_rekammedis')) {
                            const imgEl = document.createElement('img')
                            imgEl.src = `${img.file_name}`
                            imgEl.style.width = '100%'
                            imgEl.style.display = 'block'
                            imgEl.onload = () => row.normalizeHeight()

                            docWrapper.appendChild(imgEl)
                        } else {
                            const textNode = document.createTextNode(img.file_name.replace('/berkas_rm/', ''))
                            docWrapper.appendChild(textNode)
                        }

                        holder.appendChild(docWrapper)
                    })

                    row.getElement().appendChild(holder)
                },
                columns: [
                    {title: 'No Rekam Medis', field: 'Medrec'},
                    {title: 'Judul', field: 'doc_title'},
                    {title: 'Keterangan', field: 'doc_description', editor: 'input', cellEdited: updateKeterangan},
                    {title: 'Berkas', field: 'doc_path', formatter: previewBerkasInfo, cellClick: this.berkasActions},
                    {title: 'Action', formatter: function () {
                        return '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></button>'
                    }, cellClick: this.deleteBerkas},
                ]
            })
        },
        berkasActions(e, cell) {
            const id = e.target.getAttribute('data-id')
            const file_name = e.target.getAttribute('data-file_name')
            const action = e.target.getAttribute('data-action')

            switch (action) {
                case 'preview':
                    if (file_name.includes('berkas_rekammedis')) {
                        this.pdf_preview = null
                        this.preview_scan = file_name
                        const modal_preview = this.$refs.modal_preview
                        this.modal_element = new Modal(modal_preview)
                        this.modal_element.show()
                    } else {
                        this.preview_scan = null
                        this.pdf_preview = file_name
                        this.renderPDF()
                    }
                    break;

                case 'delete':
                    const uri = `/api/scan-berkas-rm/delete-berkas-file/${id}`
                    this.axios.delete(uri).then(response => {
                        if (response.data.status =='success') {
                            this.getBerkasPasien()
                        }
                    })
                    break;

                default:
                    break;
            }
        },
        deleteBerkas(e, cell) {
            const data = cell.getRow().getData()
            const id_berkas = data.id
            const uri = `/api/scan-berkas-rm/delete-berkas/${id_berkas}`

            this.axios.delete(uri).then(response => {
                if (response.data.status == 'success') {
                    this.getBerkasPasien()
                }
            })
        },
        ajaxLoader() {
            // set loading screen
        },
        AjaxResponse(url, params, response) {
            this.berkas_pasien = response.berkas_rm.data
            console.log('berkas_pasien', this.berkas_pasien)
            return response.berkas_rm
        },
        initMDLWS() {
            this.ws_mdl = new WebSocket(`ws://${this.ip_scanner}:${this.port}/DirectoryListener`)
            this.ws_mdl.addEventListener('message', (ev) => {
                let data = ev.data
                // console.log('DirectoryListener message:', data)
                if (this.valid_mime_regex.test(data)) {
                    this.handleDataUrl(data, `Scanner #${this.scanner_counter++}`)
                }
            })

            this.ws_mdl.addEventListener('error', (ev) => {
                this.ws_mdl.close();
                this.ws_mdl = null;
            });

            this.ws_mdl.addEventListener('open', (ev) => {
                this.ws_mdl.send('start');
            });
        },
        handleDataUrl(data_url, filename) {
            if (!this.valid_mime_regex.test(data_url)) {
                return false
            }

            let is_pdf = /^data:application\/pdf;base64/.test(data_url)
            let thumbnail = this.createThumbnail(data_url, is_pdf, filename, 0)
			thumbnail.attr('data-id', --this.thumbnail_id);
            // console.log('thumbnail:', thumbnail)
            this.proses_scan = false;
            this.thumbnail.push(thumbnail[0].src)
            console.log('arr_thumbs', this.thumbnail)
        },
        createThumbnail(url, is_pdf, filename, id_berkas) {
            let preview_url = is_pdf ? this.pdf_placeholder : url

            return $(`<img class="${is_pdf ? 'pdf' : 'img'}-preview" src="${preview_url}" alt="Preview Image" style="width: 300px">`)
        },
        saveThumbnail() {
            this.data_berkas.medrec = this.Medrec
            this.data_berkas.doc_path = this.thumbnail
            const uri = '/api/scan-berkas-rm/save-berkas'

            this.axios.post(uri, this.data_berkas).then(response => {
                if (response.data.status == 'success') {
                    this.getBerkasPasien()
                    this.modal_element.hide()
                }
            })
        },
        scanDocs() {
            this.initMDLWS()
            this.thumbnail = []
            const modal_scan = this.$refs.modal_scan
            this.proses_scan = false
            this.modal_element = new Modal(modal_scan)
            this.modal_element.show()

        },
        startScan() {
            this.proses_scan = true

            if (this.ws_ctwain) {
                this.ws_ctwain.close()
            }

            this.ws_ctwain = new WebSocket(`ws://${this.ip_scanner}:${this.port}/CmdTwain`);

            this.ws_ctwain.addEventListener('message', (ev) => {
                let data = ev.data
            })

            this.ws_ctwain.addEventListener('error', (ev) => {
                const ws_url = ev.currentTarget.url ?? null

                alert(`Gagal membuka koneksi WebSocket ke scanner pada url ${ws_url}`)
                this.ws_ctwain.close()
            })

            this.ws_ctwain.addEventListener('open', (ev) => {
                this.ws_ctwain.send('scan')
            })
        },
        previewImage(thumb) {
            this.preview_scan = thumb
            const modal_preview = this.$refs.modal_preview
            this.modal_element = new Modal(modal_preview)
            this.modal_element.show()
        },
        handleFileUpload() {
            if (this.file_berkas == 0) {
                this.$swal.fire({
                    title: 'Error!',
                    text: 'Silahkan Pilih Berkas Pasien',
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            } else {
                const file_input = this.$refs.file_upload
                const file = file_input ? file_input.files[0] : null
                if (file) {
                    this.file_upload = file
                    if (file.type == 'application/pdf') {
                        this.doUploadFile()
                    } else {
                        const reader = new FileReader()
                        reader.readAsDataURL(file)
                        reader.onload = () => {
                            this.preview_scan = reader.result
                            console.log('preview_scan', this.preview_scan)
                        }

                        const modal_preview = this.$refs.modal_preview
                        this.modal_element = new Modal(modal_preview)
                        this.modal_element.show()
                    }
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: 'Silahkan Pilih File',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }
        },
        async renderPDF() {
            const pdf = await pdfjsLib.getDocument(this.pdf_preview).promise;
            this.pdf_pages = Array.from({ length: pdf.numPages }, (v, i) => i + 1)
            console.log('pdf_pages', this.pdf_pages)
            console.log('pdf_preview', this.pdf_preview)

            this.pdf_pages.forEach(async (page_number, index) => {
                const page = await pdf.getPage(page_number);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = this.$refs['pdf_canvas' + (page_number - 1)][0];
                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                if (context) {
                    await page.render({ canvasContext: context, viewport: viewport }).promise;
                }
            })

            const modal_preview = this.$refs.modal_preview
            this.modal_element = new Modal(modal_preview)
            this.modal_element.show()
        },
        doUploadFile() {
            const uri = `/api/scan-berkas-rm/update-berkas`;
            if (this.file_upload.type == "application/pdf") {
                const form_data = new FormData()
                form_data.append('file_berkas', this.file_berkas)
                form_data.append('doc_path', this.file_upload)
                form_data.append('type', 'pdf')

                this.axios.post(uri, form_data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((response) => {
                    if (response.data.status == "success") {
                        this.getBerkasPasien();

                        this.$swal.fire({
                            title: 'Berhasil!',
                            text: 'Upload Berhasil',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        })
                    } else {
                        this.$swal.fire({
                            title: 'Gagal!',
                            text: `Upload Gagal. ${response.data.message}`,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }
                });
            } else {
                const data_update = {
                    file_berkas: this.file_berkas,
                    doc_path: this.preview_scan,
                };

                this.axios.post(uri, data_update).then((response) => {
                    if (response.data.status == "success") {
                        this.getBerkasPasien();
                        this.modal_element.hide();

                        this.$swal.fire({
                            title: 'Berhasil!',
                            text: 'Upload Berhasil',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        })
                    } else {
                        this.$swal.fire({
                            title: 'Gagal!',
                            text: `Upload Gagal. ${response.data.message}`,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }
                });
            }
            this.file_upload = null;
        }
    }
}
</script>
